// Flow Planner rollout. A site is enabled when its country is listed, or when the site
// itself is listed. Country enables every site in it; the site list is for enabling
// individual sites in countries that are not fully rolled out. EXCLUDED_SITES wins over
// both, so a site can be held back even when its country is enabled.
export const FLOW_PLANNER_COUNTRIES = [];
export const FLOW_PLANNER_SITES = [
  'DAB5',
  'DAT9',
  'DAU7',
  'DAX5',
  'DBA5',
  'DBA7',
  'DBA8',
  'DBK1',
  'DBK4',
  'DBK6',
  'DBL1',
  'DBL8',
  'DCD6',
  'DCX2',
  'DCX8',
  'DCY1',
  'DCY9',
  'DDA9',
  'DDC3',
  'DDC4',
  'DDC9',
  'DDF2',
  'DDF4',
  'DDM5',
  'DDT3',
  'DDT4',
  'DDT6',
  'DDT9',
  'DDW1',
  'DDW7',
  'DDX7',
  'DEB2',
  'DEW5',
  'DFH1',
  'DFL3',
  'DFL4',
  'DFL5',
  'DFL8',
  'DFT4',
  'DFX9',
  'DGE7',
  'DGI3',
  'DGR3',
  'DHO3',
  'DHO7',
  'DHO8',
  'DHT1',
  'DHT4',
  'DHX1',
  'DHX4',
  'DIA3',
  'DIA5',
  'DIB5',
  'DIB7',
  'DIL5',
  'DIL7',
  'DJE1',
  'DJE2',
  'DJE3',
  'DJE5',
  'DJZ2',
  'DJZ4',
  'DJZ6',
  'DKS3',
  'DLB2',
  'DLC1',
  'DLC4',
  'DLC8',
  'DLD1',
  'DLD7',
  'DLI3',
  'DLN2',
  'DLN4',
  'DLT2',
  'DLT3',
  'DLT6',
  'DLT7',
  'DLT8',
  'DLX7',
  'DMC3',
  'DMC4',
  'DMD2',
  'DMD4',
  'DMD5',
  'DMD6',
  'DMD8',
  'DMD9',
  'DMF3',
  'DMI9',
  'DMO3',
  'DMO4',
  'DMO6',
  'DNA4',
  'DNA6',
  'DNK7',
  'DNO2',
  'DNO3',
  'DOB2',
  'DOB4',
  'DOK2',
  'DOK6',
  'DOR2',
  'DOR3',
  'DPH7',
  'DPL2',
  'DPL7',
  'DRC6',
  'DRT3',
  'DRT4',
  'DRT7',
  'DRT8',
  'DRT9',
  'DSD1',
  'DSD4',
  'DSD5',
  'DSD8',
  'DSK4',
  'DSW3',
  'DTG5',
  'DTN6',
  'DTN7',
  'DTN8',
  'DTY7',
  'DUR9',
  'DVA2',
  'DVA3',
  'DVA5',
  'DVB4',
  'DVB5',
  'DVB7',
  'DWA2',
  'DWA5',
  'DWA6',
  'DWD6',
  'DWS4',
  'DXH1',
  'DXH5',
  'DXT2',
  'DYN3',
  'DYN7',
  'DYN9',
  'DYO2',
  'DYO5',
  'DYY4',
  'DYY5',
  'DYY8',
  'DII3',
  'DAS8',
  'DAU2',
  'DTB9',
  'DWA9',
  'DAB4',
  'DAS7',
  'DDP9',
  'DFO9',
  'DFX3',
  'DIN6',
  'DLX9',
  'DMS2',
  'DON3',
  'DPP1',
  'DSC3',
  'DYB2',
  'DYN5',
  'DTR7',
  'DBO6',
  'DLX5',
  'DRK3',
  'DJT6',
  'DIB6'
];
export const FLOW_PLANNER_EXCLUDED_SITES = [];

export const isFlowPlannerEnabledFor = (countryCode, stationCode) => {
  const station = stationCode ? stationCode.toUpperCase() : null;
  if (station && FLOW_PLANNER_EXCLUDED_SITES.includes(station)) return false;
  const country = countryCode ? countryCode.toUpperCase() : null;
  return (!!country && FLOW_PLANNER_COUNTRIES.includes(country)) || (!!station && FLOW_PLANNER_SITES.includes(station));
};
